module.exports = __webpack_public_path__ + "static/media/icon_c.382cbac5.png";